/*
     Title: incomplete-type API
     Description: incomplete-type API
     Author: Iqbal Hossain
     Date: 11-January-2022
     Modified: 11-January-2022
*/

export const INCOMPLETE_TYPE_API = {
  root: '/api/incomplete-type',
  fetch_all: 'api/incomplete-type/fetch-all',
  fetch_by_query: `/api/incomplete-type/fetch-by-query`,
  fetch_by_id: `/api/incomplete-type/fetch-by-id`,
  add: `/api/incomplete-type/add`,
  update: `/api/incomplete-type/update`,
  delete: `/api/incomplete-type/delete`,
  delete_by_range: `/api/incomplete-type/delete-range`
};

/** Change Log
 * 11-Jan-2022(Iqbal): Create (root, fetch_by_query, fetch_by_id, add, update, delete, delete_by_range )
 */
